import util from './util';
import axios from './../axios';
const apiPath = 'api/admin/care-messages';

const chatMessageApi = {
    index: query => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/index?${util.queryToString(query)}`
        );
    },
    sendMessage: entity => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/send`,
            {
                ...entity
            }
        );
    }
};

export default chatMessageApi;
